import { render } from "./service_provider.html?vue&type=template&id=a0c6330e&external"
import script from "./service_provider.js?vue&type=script&lang=js&external"
export * from "./service_provider.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__